<template>
  <div class="block">
    <el-tabs v-model="activeName" @tab-click="changeTab">
      <el-tab-pane label="我的达人" name="first">
        <my-master :activeName="activeName"></my-master>
      </el-tab-pane>
      <el-tab-pane label="分销代理的达人" name="second" v-if="isDyAppOwner">
        <agency-master :activeName="activeName" :agentName="agentName"></agency-master>
      </el-tab-pane>
    </el-tabs>
  </div>
</template>
<script>
import MyMaster from "./MyMaster";
import AgencyMaster from "./AgencyMaster";
import { mapGetters } from "vuex";
export default {
  components: {
    MyMaster,
    AgencyMaster,
  },
  data() {
    return {
      activeName: "first",
      agentName: '',
    };
  },
  mounted() {
    if (this.$route.params.agentName) {
      this.activeName = 'second'
      this.agentName = this.$route.params.agentName
    }
  },
  computed: {
    ...mapGetters(["isDyAppOwner"]),
  },
  methods: {
    // 修改tab
    changeTab() {
      this.agentName = ''
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/views/pc/kuaishou/distribution/masterList.vue